const STATE = {
  isDragModeEnabled: false,
  isLoading: false,
  menuItems: null,
  selectedModule: null,
  selectedModuleName: null,
  selectedFolderName: null,
  selectedFolder: null,
  selectedTable: null,
  moduleInfo: null,
  moduleConfiguration: null,
  tablesList: null,
  modulesList: null,
  foldersList: null,
  foldersListWithExceptions: {},
};

export default STATE;
